/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';

export interface ProjectSubtasksControllerFindByApproverId$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The user ID who is assigned as approver.
 */
  approverId: string;
}

export function projectSubtasksControllerFindByApproverId(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerFindByApproverId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerFindByApproverId.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('approverId', params.approverId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>;
    })
  );
}

projectSubtasksControllerFindByApproverId.PATH = '/o2-core/project-subtasks/{tenant}/approver/{approverId}';
